var exports = {
  "qS": "FeedCategoryBadge.module__badge___TEdHbl",
  "Kk": "FeedCategoryBadge.module__icon___TEdHbl",
  "UU": "FeedCategoryBadge.module__name___TEdHbl",
  "XN": "FeedCategoryBadge.module__openable___TEdHbl",
};

module.exports = exports;
